// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2AXAh","title":"Info_title__1eUui","selects":"Info_selects__Q24Kd","requiredAsterisk":"Info_requiredAsterisk__39lrP"};